import React from 'react';
import {Editor as CustomEditor} from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';

export default function Editor({dataKey, data, index, config, onChange}) {

    if(!config) {
        config = {
            toolbar: {
                shouldNotGroupWhenFull: true,
            },
            htmlSupport: {
                allow: [
                    {
                        name: /^.*$/,
                        styles: true,
                        attributes: true,
                        classes: true
                    }
                ]
            },
            style: {
                definitions: [
                    {
                        name: 'Article category',
                        element: 'h3',
                        classes: [ 'category' ]
                    },
                    {
                        name: 'Title',
                        element: 'h2',
                        classes: [ 'document-title' ]
                    },
                    {
                        name: 'Subtitle',
                        element: 'h3',
                        classes: [ 'document-subtitle' ]
                    },
                    {
                        name: 'Info box',
                        element: 'p',
                        classes: [ 'info-box' ]
                    },
                    {
                        name: 'Side quote',
                        element: 'blockquote',
                        classes: [ 'side-quote' ]
                    },
                    {
                        name: 'Marker',
                        element: 'span',
                        classes: [ 'marker' ]
                    },
                    {
                        name: 'Spoiler',
                        element: 'span',
                        classes: [ 'spoiler' ]
                    },
                    {
                        name: 'Code (dark)',
                        element: 'pre',
                        classes: [ 'fancy-code', 'fancy-code-dark' ]
                    },
                    {
                        name: 'Code (bright)',
                        element: 'pre',
                        classes: [ 'fancy-code', 'fancy-code-bright' ]
                    }
                ]
            },
            fontFamily: {
                supportAllValues: true
            },
            fontSize: {
                options: [ 10, 12, 14, 'default', 18, 20, 22 ],
                supportAllValues: true
            },
            htmlEmbed: {
                showPreviews: true
            },
            image: {
                styles: [
                    'alignCenter',
                    'alignLeft',
                    'alignRight'
                ],
                resizeOptions: [
                    {
                        name: 'resizeImage:original',
                        label: 'Original',
                        value: null
                    },
                    {
                        name: 'resizeImage:50',
                        label: '50%',
                        value: '50'
                    },
                    {
                        name: 'resizeImage:75',
                        label: '75%',
                        value: '75'
                    }
                ],
                toolbar: [
                    'imageTextAlternative', 'toggleImageCaption', '|',
                    'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', 'imageStyle:side', '|',
                    'resizeImage', '|', 'linkImage'
                ],
                insert: {
                    integrations: [
                        'insertImageViaUrl'
                    ]
                }
            },
            list: {
                properties: {
                    styles: true,
                    startIndex: true,
                    reversed: true
                }
            },
            link: {
                decorators: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                    toggleDownloadable: {
                        mode: 'manual',
                        label: 'Downloadable',
                        attributes: {
                            download: 'file'
                        }
                    }
                }
            },
            template: {
                definitions: [
                    {
                        title: 'The title of the template',
                        description: 'A longer description of the template',
                        data: '<p>Data inserted into the content</p>'
                    },
                    {
                        // ...
                    },
                    // More template definitions.
                    // ...
                ]
            },
            table: {
                contentToolbar: [
                    'tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties', 'toggleTableCaption'
                ]
            },
            removePlugins: ["MediaEmbedToolbar"],
            allowedContent: {
                script: true,
            },
        };
    }

    return (
        <CKEditor
            editor={ CustomEditor }
            config={ config }
            data={data}
            onChange={ ( event, editor ) => {
                const data = editor.getData();
                //console.log( { event, editor, data } );
                onChange(dataKey, data, index);
            } }
        />
    );
}
